import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlassCard, LoadingOverlay } from '../../components';
import { getSupportSettings } from '../../services/firestoreService';
import './SupportScreen.css';

export const SupportScreen = () => {
    const navigate = useNavigate();
    const [supportData, setSupportData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadSupportSettings();
    }, []);

    const loadSupportSettings = async () => {
        try {
            const settings = await getSupportSettings();
            setSupportData(settings);
        } catch (error) {
            console.error('Error loading support settings:', error);
        } finally {
            setLoading(false);
        }
    };

    const openWhatsApp = () => {
        if (supportData?.whatsappNumber) {
            window.open(`https://wa.me/${supportData.whatsappNumber.replace(/[^0-9]/g, '')}`, '_blank');
        }
    };

    const openTelegram = () => {
        if (supportData?.telegramUsername) {
            window.open(`https://t.me/${supportData.telegramUsername}`, '_blank');
        }
    };

    const openEmail = () => {
        if (supportData?.supportEmail) {
            window.open(`mailto:${supportData.supportEmail}?subject=Support - Yonex AI`, '_blank');
        }
    };

    const copyToClipboard = (text, type) => {
        navigator.clipboard.writeText(text);
        alert(`${type} copied to clipboard!`);
    };

    if (loading) {
        return (
            <div className="support-screen loading-state">
                <LoadingOverlay />
            </div>
        );
    }

    return (
        <div className="support-screen">
            <div className="screen-header">
                <button className="back-btn" onClick={() => navigate(-1)}>
                    <span className="material-icons">arrow_back</span>
                </button>
                <h1 className="screen-title">Customer Support</h1>
                <div style={{ width: 40 }}></div>
            </div>

            <div className="support-hero">
                <div className="hero-icon-wrapper">
                    <div className="hero-icon-bg"></div>
                    <span className="material-icons hero-icon">headset_mic</span>
                </div>
                <h2 className="hero-title">Need Help?</h2>
                <p className="hero-subtitle">We're here to assist you 24/7</p>
            </div>

            <div className="contact-section">
                <h3 className="section-title">Quick Contact</h3>

                <GlassCard className="contact-card" onClick={openWhatsApp}>
                    <div className="contact-icon-wrapper whatsapp-bg">
                        <span className="material-icons">chat</span>
                    </div>
                    <div className="contact-info">
                        <span className="contact-label">WhatsApp</span>
                        <span className="contact-value">{supportData?.whatsappNumber || 'Not available'}</span>
                        <span className="contact-hint">Tap to chat with us</span>
                    </div>
                    <div className="contact-action">
                        <span className="material-icons">arrow_forward_ios</span>
                    </div>
                </GlassCard>

                <GlassCard className="contact-card" onClick={openTelegram}>
                    <div className="contact-icon-wrapper telegram-bg">
                        <span className="material-icons">send</span>
                    </div>
                    <div className="contact-info">
                        <span className="contact-label">Telegram</span>
                        <span className="contact-value">@{supportData?.telegramUsername || 'Not available'}</span>
                        <span className="contact-hint">Message us on Telegram</span>
                    </div>
                    <div className="contact-action">
                        <span className="material-icons">arrow_forward_ios</span>
                    </div>
                </GlassCard>

                <GlassCard className="contact-card" onClick={openEmail}>
                    <div className="contact-icon-wrapper email-bg">
                        <span className="material-icons">email</span>
                    </div>
                    <div className="contact-info">
                        <span className="contact-label">Email</span>
                        <span className="contact-value">{supportData?.supportEmail || 'Not available'}</span>
                        <span className="contact-hint">Send us an email</span>
                    </div>
                    <div className="contact-action">
                        <span className="material-icons">arrow_forward_ios</span>
                    </div>
                </GlassCard>
            </div>

            <GlassCard className="hours-card">
                <div className="hours-header">
                    <span className="material-icons hours-icon">schedule</span>
                    <h4>Support Hours</h4>
                </div>
                <div className="hours-content">
                    <p>{supportData?.supportHours || 'Mon-Sat: 10AM - 7PM IST'}</p>
                    <span className="hours-note">We typically respond within 24 hours</span>
                </div>
            </GlassCard>


        </div>
    );
};

export default SupportScreen;
